import { DatagridConfigurableWithStickyActions } from 'shared/react-admin/Datagrids';
import { withDatagridStickyStyles } from 'shared/react-admin/Datagrids/DatagridSticky/withDatagridStickyStyles';

export const DatagridStyled = withDatagridStickyStyles(DatagridConfigurableWithStickyActions);
